<via-grid
  [columnDefs]="changeLogTableColumns"
  [rowData]="changeLogTableData"
  [gridCustomOptions]="gridCustomOptions"
>
  <div grid-header>
    <ng-content select="[change-log-header]" />
  </div>
</via-grid>
